import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateCellInfoRequest = (inputType, type, sites) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}CM/GenerateCellInfo`,
	params: { inputType, type, sites }
});
